import { defineComponent as d, ref as i, provide as o, createElementBlock as y, openBlock as p, mergeProps as S, unref as e, renderSlot as N } from "vue";
import l from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Nav/nav.js";
import { useOUIAProps as h } from "../../helpers/ouia.js";
const z = ["aria-label"], K = Symbol("NavScrollableKey"), P = Symbol("NavHorizontalKey"), _ = Symbol("NavOnSelectKey"), k = Symbol("NavFlyoutRefKey"), O = /* @__PURE__ */ d({
  name: "PfNav",
  __name: "Nav",
  props: {
    theme: { default: "dark" },
    variant: { default: "default" },
    ariaLabel: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["select"],
  setup(c, { emit: u }) {
    const t = c, f = h({ id: t.ouiaId, safe: t.ouiaSafe }), m = u, n = i(!1);
    o(K, n);
    const r = ["horizontal", "horizontal-subnav"].includes(t.variant);
    o(P, r), o(_, (a, s, b) => m("select", a, s, b));
    const v = i(null);
    return o(k, v), (a, s) => (p(), y("nav", S(e(f), {
      class: [e(l).nav, {
        [e(l).modifiers.horizontal]: e(r),
        [e(l).modifiers.subnav]: a.variant === "horizontal-subnav",
        [e(l).modifiers.scrollable]: n.value
      }],
      "aria-label": a.ariaLabel || a.variant === "horizontal-subnav" ? "Local" : "Global"
    }), [
      N(a.$slots, "default")
    ], 16, z));
  }
});
export {
  k as NavFlyoutRefKey,
  P as NavHorizontalKey,
  _ as NavOnSelectKey,
  K as NavScrollableKey,
  O as default
};
